// src/scripts/contact/internal/debugHelpers.js

import { isBrowser } from './constants.js';
import { getDebugMode, setDebugMode } from './state.js';

export const debugHelpers = {
  enable() {
    setDebugMode(true);
  },
  disable() {
    setDebugMode(false);
  },
  log(message, data = {}) {
    if (getDebugMode()) console.log(`[ContactDebug] ${message}`, data);
  },
  async checkCSRFToken() {
    if (!isBrowser) return { available: false, reason: 'Not in browser' };
    // ...original CSRF checks unchanged
  }
};